import React, {Fragment} from 'react';
import {getText} from '../../../helpers/localization';
import style from '../css/overlay.css';

const loadingOverlay = (<div className={style.loadingOverlay}>
    <div className={style.loaderContainer}>
        <div className={style.circleLoaderContainer}>
            <div className={style.circleLoader}/>
        </div>
    </div>
</div>)

export const Overlay = (props) => {

    if (props.overlayType === 'LOADING') {
        return loadingOverlay;
    }

    let overlayText
    switch (props.overlayType) {
        case 'NMB':
            overlayText = getText('NO_MORE_BETS', props.store);
            break;
        case 'LIVE':
            overlayText = <Fragment>
                {getText('EVENT_LIVE_MSG_LINE_1', props.store)} <br/>
                {getText('EVENT_LIVE_MSG_LINE_2', props.store)} <br className={style.display}/>
                {getText('EVENT_LIVE_MSG_LINE_3', props.store)}
            </Fragment>
            break;
        case 'GAME_DISABLED':
            overlayText = getText('GAME_DISABLED', props.store);
            break;
        default:
            return '';
    }

    return (
        <div className={style.overlay}>
            <div className={style.overlayText} id={'overlayText'}>
                {overlayText}
            </div>
        </div>
    );
}
  




// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/overlay.js